import React from 'react';
import './ZoneIntervention.css'; // New styles specific to this component

function ZoneIntervention({ departmentName, cities }) {
    return (
        <section className="zone-section">
            <div className="zone-header">
                <h1 className="zone-title">Zone d'Intervention</h1>
            </div>

            <div className="zone-content">
                <div className="zone-card">
                    <h2 className="zone-department">{departmentName}</h2>
                    <ul className="zone-city-list">
                        {cities.map((city, index) => (
                            <li className="zone-city-item" key={index}>
                                <span>{city}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default ZoneIntervention;
